var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLavorazioneCosteGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1034 4223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.5,140.922l-2.568-4.345-5.5,3.168V133.5h-4.952v6.245l-5.5-3.168-2.476,4.345L127,144l-5.5,3.168,2.476,4.254,5.5-3.168V154.5h4.952v-6.246l5.5,3.168,2.568-4.254L137,144Z",
    transform: "translate(914 -4355)",
    fill: "#16b240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5,140.922l-2.568-4.345-5.5,3.168V133.5h-4.952v6.245l-5.5-3.168-2.476,4.345L127,144l-5.5,3.168,2.476,4.254,5.5-3.168V154.5h4.952v-6.246l5.5,3.168,2.568-4.254L137,144l5.5-3.078",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(1034 -4223)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavorazioneCosteGreen);
export default __webpack_public_path__ + "static/media/lavorazione_coste_green.59252540772c9b2e3f83cf4b89470a8f.svg";
export { ForwardRef as ReactComponent };